import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Search, ArrowLeft, ArrowRight } from "lucide-react";
import axios from "axios";
import BlogCard from "./BlogCard";
import "./Blog.css";

const AllBlogs = () => {
  const [blogs, setBlogs] = useState([]);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const loggedInUser = useSelector((state) => state.auth.user);
  const token = loggedInUser?.refreshToken;
  const baseUrl = process.env.REACT_APP_BASE_URL;

  const fetchAllBlogs = async () => {
    try {
      const response = await axios.post(
        `${baseUrl}/all/blogs`,
        {
          page_number: currentPage,
          page_size: 20,
          order_by: "ASC",
          keyword_search: searchKeyword,
        },
        { headers: { Authorization: `Bearer ${token}` } },
      );
      if (response.data.statusType === "SUCCESS") {
        setBlogs(response.data.blogs);
        setTotalPages(response.data.total_pages || 1);
      } else {
        console.error("Failed to fetch all blogs");
      }
    } catch (error) {
      console.error("Error fetching all blogs:", error);
    }
  };

  useEffect(() => {
    fetchAllBlogs();
  }, [currentPage]);

  const handleSearch = (e) => {
    e.preventDefault();
    setCurrentPage(1);
    fetchAllBlogs();
  };

  return (
    <div className="blog-page">
      <div className="blog-page__container">
        <div className="blog-page__hero">
          <span className="blog-page__label">From our journal</span>
          <h1 className="blog-page__title">
            All <em>Blogs</em>
          </h1>

          <form onSubmit={handleSearch} className="blog-page__search">
            <div className="blog-page__search-wrap">
              <span className="blog-page__search-icon">
                <Search size={15} />
              </span>
              <input
                className="blog-page__search-input"
                type="text"
                placeholder="Search blogs…"
                value={searchKeyword}
                onChange={(e) => setSearchKeyword(e.target.value)}
              />
            </div>
            <button type="submit" className="blog-page__search-btn">
              Search
            </button>
          </form>
        </div>

        <div className="blog-page__grid">
          {blogs.length === 0 ? (
            <div className="blog-empty">No blogs found.</div>
          ) : (
            blogs.map((blog) => (
              <BlogCard
                key={blog._id}
                title={blog.title}
                description={blog.excerpt}
                imageUrl={blog.image_url}
                blogId={blog.id}
                author={blog.author}
                date={blog.publish_date}
                tags={blog.tags}
                slug={blog.slug}
              />
            ))
          )}
        </div>

        <div className="blog-page__pagination">
          <button
            className="blog-page__page-btn"
            disabled={currentPage === 1}
            onClick={() => setCurrentPage((p) => p - 1)}
          >
            <ArrowLeft size={14} />
          </button>
          <span className="blog-page__page-current">
            {currentPage} / {totalPages}
          </span>
          <button
            className="blog-page__page-btn"
            disabled={currentPage === totalPages}
            onClick={() => setCurrentPage((p) => p + 1)}
          >
            <ArrowRight size={14} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default AllBlogs;
